export const ALERT_TYPES_DETAILS_OPEN_MODAL = "ALERT_TYPES_DETAILS_OPEN_MODAL";
export const ALERT_TYPES_DETAILS_REQUEST = "ALERT_TYPES_DETAILS_REQUEST";
export const ALERT_TYPES_DETAILS_RESULT = "ALERT_TYPES_DETAILS_RESULT";
export const ALERT_TYPES_DEVICE_MODEL_REQUEST = "ALERT_TYPES_DEVICE_MODEL_REQUEST";
export const ALERT_TYPES_DEVICE_MODEL_RESULT = "ALERT_TYPES_DEVICE_MODEL_RESULT";
export const ALERT_TYPES_UPDATE_REQUEST = "ALERT_TYPES_UPDATE_REQUEST";
export const ALERT_TYPES_UPDATE_RESULT = "ALERT_TYPES_UPDATE_RESULT";